<h3>My Countries</h3>
<mat-nav-list>
  <mat-toolbar *ngFor="let country of countries$ | async" class="organizationcountrylistitem__toolbar flex-row-start-center">
    <div class="organizationcountrylistitem__flag flex-50px">
      <div class="organizationcountrylistitem__flag-placeholder">
        <img class="organizationcountrylistitem__flag-image" src="/assets/images/flags/{{ country.slug }}-flag-square-icon-64.png"
              onError="this.src='/assets/images/flags/_placeholder-flag-square-icon-64.png'">
      </div>
    </div>
    <div class="organizationcountrylistitem__name" ><a [routerLink]="['/country', country.slug]" >{{ country.name }}</a></div >
  </mat-toolbar>
</mat-nav-list>
<div *ngIf="loading" className="organizationcountrylist__loading">
  <mat-toolbar class="organizationcountrylist__loading-row flex-row"></mat-toolbar>
  <mat-toolbar class="organizationcountrylist__loading flex-row"></mat-toolbar>
  <mat-toolbar class="organizationcountrylist__loading flex-row"></mat-toolbar>
</div>
<app-organization-request-country></app-organization-request-country>
